<template>
  <div>
    <div dir="rtl">

      <div class="columns">
        <div class="column">
          <p class="has-text-weight-bold">Admin:</p>
          <select dir="rtl" v-model="staged_data.admin_id">
            <option v-for="option in adminFullList" :key="option.id" :value="option.id">{{option.full_name}}</option>
          </select>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <BaseInput v-model="staged_data.daily_sent" label="Daily Sent: " />
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <BaseInput v-model="staged_data.daily_phone_calls" label="Daily Phone Calls :" />
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <BaseInput v-model="staged_data.daily_follow_ups" label="Daily Follow Ups :" />
        </div>
      </div>

    </div>
    <div class="modal_footer">
      <a
        @click="submit(true)"
        :class="{ 'is-loading': is_submitting }"
        class="button is-info is-rounded"
        >הזן ורענן לי את הדף</a>
      <a
        @click="submit(false)"
        :class="{ 'is-loading': is_submitting }"
        class="button is-info is-rounded"
        style="margin: 10px"
        >הזן ואל תרענן</a>
    </div>
  </div>
</template>
<script>
// libraries
import { mapGetters } from 'vuex'

// components
import BaseInput from '@/components/BaseInput'

export default {
  name: 'AdminRequirmentForm',
  props: {
    payload: {
      type: Object,
      default: () => ({})
    },
    onRefresh: {
      type: Function,
      default: () => {}
    }
  },
  data () {
    return {
      staged_data: {},
      blank_staged_data: {
        admin_id: '',
        daily_sent: '',
        daily_phone_calls: '',
        daily_follow_ups: ''
      },
      is_submitting: false,
      is_refresh: false
    }
  },
  computed: {
    ...mapGetters('admins', ['adminFullList'])
  },
  async created () {
    this.staged_data = { ...this.blank_staged_data }
    if (!this.payload.is_create) {
      try {
        const r = await this.$network_utils.getAdminRequirment({
          id: this.payload.data.id
        })
        this.staged_data = r
      } catch (e) {
        console.log(e)
      }
    }
  },
  methods: {
    async upsertData (method) {
      try {
        await this.$network_utils[method](this.staged_data)
        if (this.is_refresh) {
          this.onRefresh()
        }
        this.$utils.emit('show_toast', {
          text: `Success: You successfully updated the record`
        })
      } catch (e) {
        this.$utils.emit('show_toast', { text: `Error: try again` })
        console.error(e)
      }
    },
    submit (refresh) {
      this.is_refresh = refresh
      for (const [key, value] of Object.entries(this.staged_data)) {
        if (typeof value === 'string' || value instanceof String) {
          this.staged_data[key] = value.trim()
        }
      }
      if (this.payload.is_create) {
        this.upsertData('postAdminRequirment')
      } else {
        this.upsertData('updateAdminRequirment')
      }
    }
  },
  components: {
    BaseInput
  }
}
</script>
